import { render, staticRenderFns } from "./TaskDetailsModal.vue?vue&type=template&id=c37c12f4&scoped=true&"
import script from "./TaskDetailsModal.vue?vue&type=script&lang=js&"
export * from "./TaskDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailsModal.vue?vue&type=style&index=0&id=c37c12f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37c12f4",
  null
  
)

export default component.exports